module.exports = __webpack_public_path__ + "favicon-16x16.c26fa9f6.png";